import React from "react";
import { withStyles, createStyles, WithStyles, Theme } from "@material-ui/core/styles";
import { getProducersFullGroupByIdent } from "../../../lib/api/producersfull";
import Grid from "../../../lib/components/grid";
import { GridColumns } from "./gridsetup";

const styles = (theme: Theme) =>
  createStyles({
    root: {
      padding: theme.spacing(1),
      width: "800px",
    },
  });

type Props = {
  produceradvancepaidhead_ident: number;
} & WithStyles<typeof styles>;

class ProducerAdvanceInfoUnstyled extends React.Component<Props, any> {
  constructor(props) {
    super(props);
  }

  state = {
    data: [],
    loading: true,
  };

  componentDidMount() {
    this.loadData();
  }

  loadData = async () => {
    this.setState({ loading: true });
    const resp = await getProducersFullGroupByIdent(this.props.produceradvancepaidhead_ident);
    this.setState({ loading: false, data: resp });
  };

  render() {
    const { classes } = this.props;

    return (
      <div className={classes.root}>
        <Grid loading={this.state.loading} data={this.state.data} GridColumns={GridColumns} clearFilters={"produceradvanceinfo"} />
      </div>
    );
  }
}

export default withStyles(styles)(ProducerAdvanceInfoUnstyled);
